// Peer comparison display rules (SPO-1536). The API only returns a % when
// an athlete shared at least MIN_PEER_SESSIONS sessions with teammates who
// have data; it compares with all teammates in those sessions, not by
// position.

export const MIN_PEER_SESSIONS = 3; // mirrors public-api dashboard_service

// Within ±IN_LINE_PERCENT reads as "in line" rather than above or below.
export const IN_LINE_PERCENT = 3;

// "above" | "below" | "inLine", or null when there's no comparison.
export const peerDirection = (diff) => {
  if (diff == null) return null;
  if (Math.abs(diff) < IN_LINE_PERCENT) return "inLine";
  return diff > 0 ? "above" : "below";
};

// Neutral colours: above and below look the same, so a comparison never
// reads as good or bad. The arrow alone shows the direction.
const SLATE = { bg: "#EEF2F6", text: "#334155", tooltip: "#E2E8F0" };
export const PEER_COLORS = {
  inLine: { bg: "#F3F4F6", text: "#6B7280", tooltip: "#D1D5DB" },
  above: SLATE,
  below: SLATE,
};
